import { result } from 'underscore';
import { preferenceFactory } from './preference-middleware';


function preferenceSetCallbackFactory(preferenceService) {
  return function preferenceSetCallback({ Name, Data }) {
    preferenceService.setAtAccountLevel({ Name, Data });
  };
}

function preferenceGetCallbackFactory(preferenceService) {
  return function preferenceGetCallback({ Name }) {
    const preference = preferenceService.findByNameAtAccountLevel(Name);
    return result(preference, 'Data');
  };
}

export function campaignPreferenceFactory(gridName, preferenceService) {
  return preferenceFactory(gridName, preferenceSetCallbackFactory(preferenceService), preferenceGetCallbackFactory(preferenceService));
}

